import { render, staticRenderFns } from "./UPIpayment.vue?vue&type=template&id=2183c7c7&scoped=true"
import script from "./UPIpayment.vue?vue&type=script&lang=js"
export * from "./UPIpayment.vue?vue&type=script&lang=js"
import style0 from "./UPIpayment.vue?vue&type=style&index=0&id=2183c7c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2183c7c7",
  null
  
)

export default component.exports